import { Component, Vue } from "vue-property-decorator";
import audioPlayer from "../../synth/AudioPlayer";
import { MiniPlayerConfig } from "./MiniPlayerConfig";
import { analyticsController } from "../../user/analytics/AnalyticsController";
import { synthController } from "../../synth/SynthController";
import { playerConfig } from "../../player/models/PlayerConfig";
import { defaultLoopParameters, LoopParameters } from "../../player/models/parameters/LoopParameters";
import { RhythmicBloc } from "../../playable/models/RhythmicBloc";

@Component
export default class MiniPlayerMixin extends Vue {

  private isLoading = false;
  private isRhytmicBloc = false;
  private wantsToPlay = false;
  private timeout: NodeJS.Timeout | null = null;
  miniPlayerConfig: MiniPlayerConfig | null = null;

  get progress() {
    const startDivision = this.miniPlayerConfig?.divisions[0].id
    return this.miniPlayerConfig ? Math.round(((audioPlayer.state.timer - startDivision!) / this.miniPlayerConfig.divisions.length) * 100) : 0;
  }
  set progress(value: number) {
    this.pause()
    if(this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(() => {
      const startDivision = this.miniPlayerConfig?.divisions[0].id ?? 0;
      const length = this.miniPlayerConfig?.divisions.length || 0;
      audioPlayer.emit('setTimer', Math.round((value / 100) * length) + startDivision);
    }, 200)
  }
  get playerStatus() {
    return this.isLoading || synthController.state.isLoading ? 'loading' : audioPlayer.state.playerStatus
  }

  mounted() {
    synthController.on('synthIsLoaded', this.onSynthIsLoaded)
    this.$root.$on('reloadPlayableContent', this.reload)
  }

  beforeDestroy() {
    synthController.off('synthIsLoaded', this.onSynthIsLoaded)
    this.$root.$off('reloadPlayableContent', this.reload)
    audioPlayer.off('loopEnd', this.playFromBeginning)
    this.pause()
    this.miniPlayerConfig = null
    audioPlayer.resetPlayableContent()
    playerConfig.resetPlayerConfigState()
  }

  reload() {
    if(this.miniPlayerConfig) {
      this.load(this.miniPlayerConfig)
    }
  }

  load(miniPlayerConfig: MiniPlayerConfig, playAfterLoad = false) {
    this.isLoading = true
    audioPlayer.off('loopEnd', this.playFromBeginning)
    this.isRhytmicBloc = miniPlayerConfig.playableContent instanceof RhythmicBloc
    this.miniPlayerConfig = miniPlayerConfig;
    audioPlayer.initPlayableContent(miniPlayerConfig.playableContent, miniPlayerConfig.divisions, false)
    playerConfig.state.soundParameters = miniPlayerConfig.soundParameters
    playerConfig.state.loopParameters = defaultLoopParameters
    if (this.isRhytmicBloc) {
      playerConfig.state.loopParameters = new LoopParameters('RHYTHMIC_BLOC', miniPlayerConfig.playableContent)
    }
    this.isLoading = false

    if (miniPlayerConfig.autoLoop) {
      audioPlayer.on('loopEnd', this.playFromBeginning)
    }

    if (playAfterLoad) {
      this.playFromBeginning()
    }
  }
  close() {
    this.pause()
    this.miniPlayerConfig = null
    analyticsController.logBasicAnalyticsEvent('closed mini player', 'Mini Player Events');

    audioPlayer.off('loopEnd', this.playFromBeginning)

    if (!this.$route.name?.includes('Player')) {
      audioPlayer.resetPlayableContent()
    }
  }

  playFromBeginning() {
    if (this.$route.name?.includes('Player')) {
      return
    }
    
    audioPlayer.emit('setTimer', this.miniPlayerConfig?.divisions[0].id ?? 0, true, false)
    this.play()
  }
  private onSynthIsLoaded() {
    if (this.wantsToPlay) {
      this.play()
    }
  }

  async play() {
    this.isLoading = false

    if (this.$route.name?.includes('Player')) {
      return
    }

    if (!synthController.isLoaded) {
      this.isLoading = true
      this.wantsToPlay = true
      await synthController.initSynth()
      return
    }
    this.wantsToPlay = false
    audioPlayer.emit('play', false)
  }
  pause() {
    this.wantsToPlay = false
    if (this.playerStatus !== 'pause') {
      audioPlayer.emit('pause')
    }
  }
  reset() {
    this.pause()
    setTimeout(() => {
      audioPlayer.emit('setTimer', this.miniPlayerConfig?.divisions[0].id ?? 0, true, false)
    }, 200)
  }
}